import { withProps, flattenProp } from 'recompose'
import moment from 'moment'
import classNames from 'classnames'

import CircleLoader from '@components/CircleLoader'
import FeatureBlock from '@components/FeatureBlock'

import './styles.scss'

const $ParkingInfoSideBar = ({
    address,
    loading,
    phone,
    email,
    freeSpaces,
    children,
    isOpen247,
    openingHours,
    openingHoursPerWeekday,
    totalSpaces,
    garageIsUnderground,
    mscpGarageIsAboveGround,
    isOnSurface,
    womenOnly,
    heightRestriction,
    stayRestrictions,
}) => {
    const allWeekDaysHaveOpeningHours = !openingHoursPerWeekday.some(val => !val)
    const showDetails = [
        isOpen247,
        openingHours,
        allWeekDaysHaveOpeningHours,
        totalSpaces,
        freeSpaces,
        mscpGarageIsAboveGround,
        isOnSurface,
        heightRestriction,
        garageIsUnderground,
        womenOnly,
        stayRestrictions,
    ].some(val => !!val)

    const combineAddress = address => {
        if (address) {
            const { lines, zipCode = '', city = '' } = address
            return `${lines.join(' ')} ${zipCode} ${city}`
        }
        return ''
    }
    const combinedAddress = React.useMemo(() => combineAddress(address), [address])

    return (
        <div className="d-flex-column booking__parking-info-sidebar">
            <div className="parking-info-sidebar__map">{children}</div>
            <div
                className={classNames('parking-info-sidebar', {
                    'is-loading': loading,
                })}>
                {loading ? (
                    <CircleLoader />
                ) : (
                    <>
                        <div className="d-flex-column">
                            {address && <FeatureBlock size="xs" label={combinedAddress} icon="address" />}
                            {phone && (
                                <FeatureBlock size="xs" label={<a href={`tel:${phone}`}>{phone}</a>} icon="phone" />
                            )}
                            {email && (
                                <FeatureBlock size="xs" label={<a href={`mailto:${email}`}>{email}</a>} icon="email" />
                            )}
                        </div>
                        <div className="d-flex-column">
                            {showDetails && (
                                <>
                                    <h5 className="parking-info-sidebar__title">
                                        {<T>booking.parking.information</T>}
                                    </h5>

                                    {(isOpen247 || openingHours || allWeekDaysHaveOpeningHours) && (
                                        <FeatureBlock
                                            size="xs"
                                            label={<T>label.park.opening.hours</T>}
                                            icon="clock"
                                            details={isOpen247 && <T>label.park.247</T>}>
                                            {!isOpen247 && allWeekDaysHaveOpeningHours
                                                ? openingHoursPerWeekday.map((time, index) => (
                                                      <div key={index} className="opening-hours-day">
                                                          <span className="opening-hours-day-abbr">
                                                              <T>{moment.weekdaysShort(index + 1)}</T>
                                                          </span>
                                                          <span className="opening-hours-day-time">{time}</span>
                                                      </div>
                                                  ))
                                                : openingHours && openingHours}
                                        </FeatureBlock>
                                    )}
                                    {totalSpaces && (
                                        <FeatureBlock
                                            size="xs"
                                            label={
                                                <T>
                                                    {freeSpaces ? 'label.park.spaces.free' : 'label.park.spaces.total'}
                                                </T>
                                            }
                                            icon="park"
                                            details={`${
                                                freeSpaces ? `${freeSpaces}/` : ''
                                            }${totalSpaces}`}></FeatureBlock>
                                    )}
                                    {mscpGarageIsAboveGround && (
                                        <FeatureBlock size="xs" label={<T>label.park.mscp</T>} icon="multistore" />
                                    )}
                                    {isOnSurface && (
                                        <FeatureBlock size="xs" label={<T>label.park.onsurface</T>} icon="outside" />
                                    )}
                                    {!!heightRestriction && (
                                        <FeatureBlock
                                            size="xs"
                                            label={<T>label.park.max.height</T>}
                                            icon="height"
                                            details={`${heightRestriction}m`}
                                        />
                                    )}
                                    {garageIsUnderground && (
                                        <FeatureBlock size="xs" label={<T>label.park.underground</T>} icon="indoor" />
                                    )}

                                    {womenOnly && (
                                        <FeatureBlock size="xs" label={<T>label.park.women.only</T>} icon="woman" />
                                    )}

                                    {stayRestrictions && (
                                        <FeatureBlock
                                            size="xs"
                                            label={<T>label.park.stay.restriction</T>}
                                            icon="restriction"
                                            details={stayRestrictions}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

const ParkingInfoSideBar = compose(
    flattenProp('location'),
    withProps(
        ({
            openingHoursMonday,
            openingHoursTuesday,
            openingHoursWednesday,
            openingHoursThursday,
            openingHoursFriday,
            openingHoursSaturday,
            openingHoursSunday,
        }) => ({
            openingHoursPerWeekday: [
                openingHoursMonday,
                openingHoursTuesday,
                openingHoursWednesday,
                openingHoursThursday,
                openingHoursFriday,
                openingHoursSaturday,
                openingHoursSunday,
            ],
        })
    )
)($ParkingInfoSideBar)

export { ParkingInfoSideBar }
